import type { IconData } from '@stacksjs/iconify-core'

export const periscopeCircle: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.993 5C7.79 5 6.005 6.758 6.005 8.926c0 2.577 3.243 6.06 3.988 6.06s3.987-3.385 3.987-6.06C13.98 6.758 12.195 5 9.993 5m-.018 6.865c-1.568 0-2.839-1.251-2.839-2.795c0-1.543 1.271-2.794 2.839-2.794c1.567 0 2.838 1.25 2.838 2.794s-1.27 2.795-2.838 2.795\"/><path d=\"M9.975 6.816q-.105 0-.21.01c.17.192.272.442.272.716c0 .606-.498 1.096-1.113 1.096c-.43 0-.804-.24-.989-.593c-.16.308-.25.656-.25 1.025c0 1.245 1.025 2.255 2.29 2.255c1.264 0 2.29-1.01 2.29-2.255s-1.025-2.254-2.29-2.254\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default periscopeCircle
